import React, { useContext } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import useOrderPackage from '../../../hooks/useOrderPackage';
import useOptions from '../../../hooks/useOptions';
import Spinner from '../../Spinner';
import checkIcon from './check.png';
import OrderPackageItem from './OrderPackageItem';
import styles from './Confirm.module.scss';
import PastImageItems from '../../PastImagesContent/PastImageItems';
import pastImageStyles from '../PreviousImages/v2/PreviousImages.module.scss';
import { useIsFetching } from '@tanstack/react-query';
import cn from 'classnames';
import Button from '../../Button/v2';
import routes from '../../../routes';
import usePastImages from '../../../hooks/usePastImages';

export default function Confirm() {
  const history = useHistory();
  const { orderPackageId } = useParams();

  const isFetching = useIsFetching();

  const { data: orderPackage, isLoading } = useOrderPackage(orderPackageId);
  const { data: pastImages } = usePastImages({ studentId: orderPackage?.student?.id, additionalQuery: {} });
  const { data: options, isLoadingOptions } = useOptions(orderPackage?.packageId, orderPackage?.student?.schoolId);

  const renderSpinner = () => {
    if (isFetching) return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Spinner color="blue" />
      </div>
    );

    return null;
  };

  const yearbookOption = options?.find(opt => opt.name.includes('Yearbook'))
  const imageType = options?.find(opt => opt.id.toString() === orderPackage?.optionId?.toString())?.imageTypes?.find(it => it.name.includes('8x10'))
  const sheet = orderPackage?.sheets.find(s => s.imageTypeId.toString() === imageType?.id?.toString())
  const handleContinue = () => {
    history.push(routes.review());
  }

  const handlePastItems = ({ packageId, studentImage }) => {
    localStorage.setItem(`currentSeason-${studentImage.studentId}`, studentImage.folder);
    history.push(routes.elementaryMultiPoseBuilder(packageId, { step: 'select-package' }));
  };

  if (isLoading && isLoadingOptions) return <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%)' }}><Spinner color='blue' /></div>;

  if (!orderPackage) return <></>;

  if (orderPackage?.apiOption?.isBuyAll && imageType && sheet) {
    return (
      <div className={styles.page}>
        <div className={styles.alert}>
          <img alt="Check" src={checkIcon} />
          <p>Product successfully added to your cart!</p>
        </div>
        <OrderPackageItem orderPackage={orderPackage} skipImage />
        <hr />

        <div className={styles.btnsContainer}>
          <Button variant="primary" onClick={() => history.push(routes.multiPoseEdit(orderPackageId, { sheetId: sheet.id, type: 'Sheet' }))}>
            Continue to 8x10 Selection
          </Button>
        </div>
      </div>
    )
  }

  if (orderPackage?.apiOption?.isBuyAll && yearbookOption) {
    return (
      <div className={styles.page}>
        <div className={styles.alert}>
          <img alt="Check" src={checkIcon} />
          <p>Product successfully added to your cart!</p>
        </div>
        <OrderPackageItem orderPackage={orderPackage} skipImage />
        <hr />

        <div className={styles.btnsContainer}>
          <Button variant="primary" onClick={() => history.push(routes.seniors.packageBuilder(orderPackage.packageId, {opt: yearbookOption?.id, step: 'build' }))}>
            Continue to Select Yearbook Pose
          </Button>
        </div>
      </div>
    )
  }

  if (orderPackage?.apiOption?.isBuyAll) {
    return (
      <div className={styles.page}>
        <div className={styles.alert}>
          <img alt="Check" src={checkIcon} />
          <p>Product successfully added to your cart!</p>
        </div>
        <OrderPackageItem orderPackage={orderPackage} skipImage />
        <hr />

        <div className={styles.btnsContainer}>
          <Button variant="primary" onClick={() => history.push(routes.holiday.builder({
            o: orderPackageId,
            optional: true,
            pid: orderPackage.packageId
          }))}>
            Continue
          </Button>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.page}>
      <div className={styles.alert}>
        <img alt="Check" src={checkIcon} />
        <p>Product successfully added to your cart!</p>
      </div>
      <OrderPackageItem orderPackage={orderPackage} />
      <hr />
      {renderSpinner()}
      <div className={cn({ [styles.hidden]: isFetching })}>
        <Button fullWidth onClick={handleContinue}>Continue</Button>
        {(pastImages || []).length > 0 && <p className={styles.additionalImagesHeader}>Select Additional Images</p>}
        <div className={pastImageStyles.grid}>
          <PastImageItems
            student={orderPackage?.student}
            onContinue={handlePastItems}
          />
        </div>
      </div>
    </div>
  );
}
